import {colors} from "@c10h/colors";
import {QA, SectionDivider} from "@components/Faq/Faq";
import {Testimonial} from "@components/TestimonialSlider";
import {useTranslation} from "ni18n";
import React from "react";

import {V5Img} from "../components/_common/Carbon";
import {useFaqIndex} from "../hooks/useFaqIndex";

type Return = {
  defaultTestimons?: Testimonial[];
  defaultHead?: string | JSX.Element;
  faq: (QA | SectionDivider)[];
};

const useCovidReadyComplianceConstants = (): Return => {
  const i18n = useTranslation();

  const faq = useFaqIndex([
    "Is my employee's health information secure?",
    "Can employers see an employee's private medical information?",
    "What type of data does the dashboard show?",
    "Is the dashboard updated with real time data?",
    "Can employees upload vaccine information if they did not get their vaccination through Carbon Health?",
    "Can an employee opt-out for religious or medical reasons?",
    "What protections does Carbon have in place to protect my personal and health information from hackers or outsiders getting into the app or into their databases that store my information?",
    "Where do they store this information?",
  ]);

  const defaultTestimons = [
    {
      body: i18n.t(
        "Carbon Health has been a huge relief in creating a trusting environment for all our employees. They’ve enabled us to have testing, contact tracing, & provide timely test results.",
      ),
      who: {
        name: "Dave Kaval",
        who: "President, Oakland Athletics",
      },
      bg: colors.darkerMint,
      color: "#F9F9F9",
      headImg: (
        <V5Img
          src="/CovidReadyCompliance/oakland-athletics.svg"
          alt="Oakland Athletics"
          width={75}
          height={75}
        />
      ),
      hideHeadTitle: true,
    },
    {
      body: i18n.t(
        "We were impressed with Carbon Health’s sharp focus on COVID-19 and data, and have partnered with them to provide tools to keep our employees safe as we build back to a better future.",
      ),
      who: {
        name: "Sholeh Esmaili-Montoya",
        who: "VP of People and Places",
      },
      bg: colors.darkerPurple,
      color: "#F9F9F9",
      headImg: (
        <V5Img
          src="/CovidReadyCompliance/bolt-threads.svg"
          alt="Bolt Threads"
          width={174}
          height={55}
        />
      ),
      hideHeadTitle: true,
    },
  ];
  return {defaultTestimons, faq};
};

export default useCovidReadyComplianceConstants;
